import * as React from 'react';
import { UserRole } from '../../types/UserRole';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ProtectedPage } from '../genericComponents/Page/ProtectedPage/ProtectedPage';

export class MaintenancePage extends React.Component {
    render() {
        return (
            <ProtectedPage
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.NOT_LOGED_IN,
                    UserRole.SEMI_PRO,
                    UserRole.SUPER_ADMIN,
                    UserRole.USER,
                ]}
            >

                <div
                    className="col-12 container-fluid align-items-center justify-content-center"
                    style={
                        {
                            background: '#111217',
                            height: '100%'
                        }
                    }
                >
                    <div className="col-12 text-center HeaderElement">
                        <img
                            className=" text-center HeaderElement"
                            style={{marginTop: '5%'}}
                            src={require('./logo.jpg')}
                            alt="Photo de profil"
                        />
                    </div>

                    <p
                        className=" text-center HeaderElement"
                        style={{fontSize: '40px', color: 'white'}}
                    >Site en maintenance
                    </p>
                </div>
            </ ProtectedPage>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MaintenancePage/MaintenancePage.tsx